import { Edit } from 'react-admin';
import { BackButton } from '../../../helperComponents/BackButton';
import { transform } from '../../../../helpers';
import { ConversionsReportsForm } from './ConversionsReports.Form';

export const ConversionsReportsEdit = (props) => (
  <>
    <BackButton path="/conversion_reports" />
    <span className="h4">Edit Offline Conversion Upload</span>
    <Edit {...props} title=" " transform={transform('affiliate_ids')}>
      <ConversionsReportsForm isCreate={false} />
    </Edit>
  </>
);
